import classNames from "classnames";

import type {ISearchComboboxKbdProps} from "../types/ISearchComboboxKbdProps";

import * as styles from "./SearchComboboxKbd.module.css";

/** The ↵ key cap next to the active row. Decorative - Enter is announced by the combobox itself. */
export const SearchComboboxKbd = (props: ISearchComboboxKbdProps) => {
    const {children = "↵", className} = props;

    return (
        <span className={classNames(styles.kbd, className)} aria-hidden="true">
            {children}
        </span>
    );
};
import classNames from "classnames";

import type {ISearchComboboxKbdProps} from "../types/ISearchComboboxKbdProps";

import * as styles from "./SearchComboboxKbd.module.css";

/** The ↵ key cap next to the active row. Decorative - Enter is announced by the combobox itself. */
export const SearchComboboxKbd = (props: ISearchComboboxKbdProps) => {
    const {children = "↵", className} = props;

    return (
        <span className={classNames(styles.kbd, className)} aria-hidden="true">
            {children}
        </span>
    );
};
